import styled from '@emotion/styled';

const Container = styled.div`
  padding: 16px;
`;

const TinyShingle = styled.div`
  max-width: 760px;
`;

const StyledCode = styled.pre`
  background-color: rgb(220, 220, 220);
  padding: 16px;
  overflow: auto;
`;

const Test = () => (
  <Container>
    <h2>Shingle Widget Test Page</h2>
    <h5>This page was created for non-configurator options. Not meant for public use.</h5>
    <br />
    <br />
    <hr />
    <h2> Legacy </h2>

    <div className="oc_shingle_view" data-shingle="trudefinition-duration" />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
></div>`}
      </StyledCode>
    </code>

    <div className="oc_shingle_view" data-shingle="trudefinition-duration" data-view="shingle" />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
  data-view="shingle"
></div>`}
      </StyledCode>
    </code>

    <div className="oc_shingle_view" data-shingle="trudefinition-duration" data-layout="stacked" />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
  data-layout="stacked"
></div>`}
      </StyledCode>
    </code>

    <div className="oc_shingle_view" data-shingle="trudefinition-duration" data-layout="stacked" data-view="shingle" />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
  data-layout="stacked"
  data-view="shingle"
></div>`}
      </StyledCode>
    </code>

    <TinyShingle className="oc_shingle_view" data-shingle="trudefinition-duration" />

    <code>
      <StyledCode>
        {`<!-- width less than 768px -->;

<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
></div>`}
      </StyledCode>
    </code>

    <hr />
    <h2>Mr Roof</h2>

    <div
      className="oc_shingle_view"
      data-shingle="oakridge"
      data-style="ranch"
      data-allowed-colors="brownwood desert-tan driftwood estate-gray onyx-black teak chateau-green shasta-white"
    />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="oakridge"
  data-style="ranch"
  data-allowed-colors="brownwood desert-tan driftwood estate-gray onyx-black teak chateau-green shasta-white"
></div>`}
      </StyledCode>
    </code>

    <div
      className="oc_shingle_view"
      data-shingle="trudefinition-duration"
      data-style="two-story-2"
      data-allowed-colors="brownwood chateau-green desert-tan driftwood estate-gray harbor-blue onyx-black teak terra-cotta black-sable pacific-wave storm-cloud"
    />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration"
  data-style="two-story-2"
  data-allowed-colors="brownwood chateau-green desert-tan driftwood estate-gray harbor-blue onyx-black teak terra-cotta black-sable pacific-wave storm-cloud"
></div>`}
      </StyledCode>
    </code>

    <div
      className="oc_shingle_view"
      data-shingle="trudefinition-duration-flex"
      data-style="two-story-1"
      data-allowed-colors="antique-silver brownwood desert-tan driftwood estate-gray onyx-black teak"
    />

    <code>
      <StyledCode>
        {`<div class="oc_shingle_view"
  data-shingle="trudefinition-duration-flex"
  data-style="two-story-1"
  data-allowed-colors="antique-silver brownwood desert-tan driftwood estate-gray onyx-black teak"
></div>`}
      </StyledCode>
    </code>
  </Container>
);

export default Test;
